import React from 'react';
import { ButtonUI } from '@next-order/next-order-components';
import { isLightColor } from './utils';
import './index.css';

export default function SignIn({
  themeColors,
  onClick,
  userDetails,
  userLoyaltyDetails,
  onLoyaltySignUp,
}) {
  // Check if background color is light
  const isLightBackground = isLightColor(themeColors.backgroundColor);

  // Create dynamic style for the Create Account button
  const createAccountButtonStyle = {
    backgroundColor: themeColors.backgroundColor,
    ...(isLightBackground && {
      color: themeColors.mainTextColor,
      border: '1px solid rgba(0, 0, 0, 0.2)',
    }),
  };

  // Create dynamic className for the Create Account button
  const createAccountButtonClassName = `mb-4 border-none${
    isLightBackground ? ' shadow-cw' : ''
  }`;

  return (
    <div className='loyalty-sign-in-container'>
      {
        // userDetails && userLoyaltyDetails === null &&
        <ButtonUI
          fullWidth
          size='xl'
          rounded='xl'
          color='primary'
          extendedClassName={createAccountButtonClassName}
          style={createAccountButtonStyle}
          fontSize='lg'
          // onClick={onLoyaltySignUp}
          onClick={(e) => {
            !userDetails ? onClick(e) : onLoyaltySignUp();
          }}
        >
          Create Account
        </ButtonUI>
      }
      {
        // !userDetails &&
        <ButtonUI
          fullWidth
          size='xl'
          rounded='xl'
          variant='text'
          color='accent'
          fontSize='lg'
          extendedClassName='bg-white text-black shadow-cw'
          // onClick={onClick ? (e) => onClick(e) : () => {}}
          onClick={(e) => {
            !userDetails ? onClick(e) : onLoyaltySignUp();
          }}
        >
          Sign In
        </ButtonUI>
      }
    </div>
  );
}
